import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Login.css'; // 👈 Reuse same CSS used in Login/Register

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [num1, setNum1] = useState(Math.floor(Math.random() * 10) + 1);
  const [num2, setNum2] = useState(Math.floor(Math.random() * 10) + 1);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const refreshCaptcha = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setCaptchaAnswer('');
  };

  const handleReset = async (e) => {
    e.preventDefault();
    const correctAnswer = num1 + num2;

    if (parseInt(captchaAnswer) !== correctAnswer) {
      setError('❌ Incorrect CAPTCHA answer.');
      setMessage('');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('✅ Password reset email sent!');
      setError('');
    } catch (err) {
      setError('❌ ' + err.message);
      setMessage('');
    }
  };

  return (
    <div className="container mt-5">
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" style={{ height: '100px', marginBottom: '20px' }} />
        <h1 className="display-4 text-primary fw-bold">KASHMIR JOBS</h1>
        <p className="lead">Reset your account password</p>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">Forgot Password</h3>

              {message && <div className="alert alert-success text-center">{message}</div>}
              {error && <div className="alert alert-danger text-center">{error}</div>}

              <form onSubmit={handleReset}>
                <div className="mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Solve to Continue:</label>
                  <div className="captcha-group">
                    <input type="text" value={num1} readOnly className="captcha-box" />
                    <span>+</span>
                    <input type="text" value={num2} readOnly className="captcha-box" />
                    <span>=</span>
                    <input
                      type="number"
                      placeholder="?"
                      value={captchaAnswer}
                      onChange={(e) => setCaptchaAnswer(e.target.value)}
                      required
                      className="captcha-input"
                    />
                    <button
  type="button"
  className="refresh-btn"
  onClick={refreshCaptcha}
  title="Refresh CAPTCHA"
>
  <i className="bi bi-arrow-clockwise"></i>
</button>

                  </div>
                </div>

                <div className="d-grid">
                  <button className="btn btn-primary" type="submit">
                    Send Reset Link
                  </button>
                </div>
              </form>

              <div className="text-center mt-3">
                <Link to="/login">← Back to Login</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
